module.exports = __webpack_public_path__ + "img/metamask-horizontal.1fb01469.png";